// ensure that every key has unique value
export const draggableItemTypes = {
    GALLERY_IMAGE: "gallery_image"
};
